import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79fa1aec")

_pushScopeId("data-v-79fa1aec")
const _hoisted_1 = { class: "sound" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"point\" data-v-79fa1aec></div><div class=\"point\" data-v-79fa1aec></div><div class=\"point\" data-v-79fa1aec></div><div class=\"point\" data-v-79fa1aec></div><div class=\"point\" data-v-79fa1aec></div>", 5)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})